<template>
  <div class="right_body_s" v-loading="isLoading">
    <Panel>
      <template v-slot:panel-top>
        <ToolBar
          class="infoActive_rumb"
          :sdata="sdata"
          @edit="onEditCategory"
          @add="onAddResource"
          @del="del"
          @restore="restore"
          isAdd
          isEdit
          isDelStatus
        >
          <!-- <span
            class="btn infoRight_sub_btn del_btn"
            style="margin-right:95px"
            @click.stop="onSubCheck"
          >检查数据</span>
          <span class="btn infoRight_sub_btn save_btn" @click.stop="onSubSave">提交数据</span>-->
        </ToolBar>
      </template>
      <template v-slot:panel-main>
        <FormGridPanel
          :tableColumns="columns"
          @EdMaterialGroup="getMaterialGroup"
          @DelCategory="DelCategory"
          @RestoreCategory="RestoreCategory"
          @cellClick="cellClick"
          ref="FormGridPanel"
        ></FormGridPanel>
      </template>
    </Panel>
    <el-dialog
      customClass="customWidth"
      :title="title"
      :visible.sync="isShowMaterialDialog"
      @close="cancelSelect"
      v-dialogDrag
    >
      <category-ne-window class="contnet_box" :fromData="fromData" ref="content"></category-ne-window>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelect">取 消</el-button>
        <el-button type="primary" @click="selectMattersOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import CategoryNeWindow from "./ui/MtrlCategoryNeWindow.vue";
import ToolBar from "components/btn/listBtn.vue";
import FormGridPanel from "components/grid/CatFormGridPanel.vue";
import Panel from "components/container/BasePanel.vue";
import { URL } from "./service/CatManage.service.js";
import { MatcatmanageApi } from "api/base.js";

export default {
  components: { ToolBar, CategoryNeWindow, Panel, FormGridPanel },
  data() {
    return {
      sdata:{},
      columns: [
        { type: "radio", title: "选择", width: 60, fixed: "left" },
        { type: "seq", width: 80, title: "序号", fixed: "left" },
        // {
        //   field: "tenantId",
        //   title: "租户ID",
        //   editRender: { name: "input" }
        // },
        // {
        //   field: "modifyUserName",
        //   title: "更改人员名",
        //   editRender: { name: "input" }
        // },
        // {
        //   field: "modifyUserCode",
        //   title: "更改人员编码",
        //   editRender: { name: "input" }
        // },
        // 单元格渲染，自动读取字典配置
        {
          field: "materialGroup",
          title: "物料组编码",
          editRender: { name: "input" }
        },
        // 单元格编辑渲染，自动读取字典配置
        {
          field: "materialGroupDesc",
          title: "物料组描述",
          editRender: { name: "input" }
        },
        {
          field: "maintainStatus",
          title: "物料组状态",
          editRender: { name: "input" },
          formatter(row) {
            return row.row.maintainStatus == "X" ? "已删除" : "未删除";
          }
        }
      ],
      isShowMaterialDialog: false,
      formLabelWidth: "100px",
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      fromData: {
      },
      title: ""
    };
  },
  created() {
    this.loadResourceDataset();
  },
  updated: function() {},
  methods: {
    //子组件向父组件传过来的,修改时用
    async getMaterialGroup(data) {
      console.log(data);
      if (data) {
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$get(MatcatmanageApi.find, {
          materialGroupId: data
        });
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        console.log(res);
        if (res.status && res.data) {
          this.fromData = res.data;
          this.title = "修改物料类别";
          this.isShowMaterialDialog = true;
        } else {
          this.$message.error("操作失败，请重试！");
        }
      } else {
        this.$message.error("请选择需要修改的物料类别信息！");
      }
    },
    //子组件向父组件传过来的,删除时用
    async DelCategory(data){
      console.log(data)
      this.sdata = data
      if (data) {
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
        this.changeDataStatus(MatcatmanageApi.del," 删除成功！","X",data.materialGroupId);
      }).catch(() => {});
        // this.isLoading = true;
        // this.loadingBg = "rgba(255,255,255,0.5)";
        // this.loadingTxt = "数据处理中...";
        // let res = await this.$get(MatcatmanageApi.del, {
        //   materialGroupId: data.materialGroupId
        // });
        // let json = JSON.stringify(this.fromData);
        // console.log(json);
        // this.isLoading = false;
        // console.log(res);
        // if (res.status && res.data) {
        //   this.$message.success(res.msg);

        // } else {
        //   this.$message.error("操作失败，请重试！");
        // }
      } else {
        this.$message.error("请选择需要删除的信息！");
      }
    },
    //子组件向父组件传过来的,恢复删除时用
    async RestoreCategory(data){
      console.log(data)
      this.sdata = data
      if (data) {
      this.$confirm('确定恢复这条记录, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
      }).then(() => {
        this.changeDataStatus(MatcatmanageApi.restore," 恢复成功！","",data.materialGroupId);
      }).catch(() => {});
        // this.isLoading = true;
        // this.loadingBg = "rgba(255,255,255,0.5)";
        // this.loadingTxt = "数据处理中...";
        // let res = await this.$get(MatcatmanageApi.del, {
        //   materialGroupId: data.materialGroupId
        // });
        // let json = JSON.stringify(this.fromData);
        // console.log(json);
        // this.isLoading = false;
        // console.log(res);
        // if (res.status && res.data) {
        //   this.$message.success(res.msg);

        // } else {
        //   this.$message.error("操作失败，请重试！");
        // }
      } else {
        this.$message.error("请选择需要恢复的信息！");
      }
    },
    cellClick(data){
        this.$set(this.sdata,'maintainStatus',data.maintainStatus);
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status,data){
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      let res = await this.$get(api,{materialGroupId:data});
      this.isLoading = false;
      if(res.status){
        this.$refs.FormGridPanel.getList();
        this.$message.success("物料组 " + data + message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
      }
    },
    /**
     * 加载资源列表
     */
    async loadResourceDataset() {},
    /**
     * 触发添加资源
     */
    onAddResource() {
      this.title = "新增物料类别";
      this.isShowMaterialDialog = true;
    },
    /**
     * 编辑
     */
    onEditCategory() {
      this.$refs.FormGridPanel.onEditCategory();
    },
    //删除
    del(){
      this.$refs.FormGridPanel.onDelCategory();
      // let vm = this;
      // if(!this.sdata.materialId){
      //   this.$message.error('请选择需要删除的记录');
      //   return;
      // }
      // this.$confirm('确定删除这条记录, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.changeDataStatus(matterApi.del,"删除成功！","X");
      // }).catch(() => {});
    },
    //恢复删除
    restore(){
      this.$refs.FormGridPanel.onRestoreCategory();
      // let vm = this;
      // if(!this.sdata.materialId){
      //   this.$message.error('请选择需要恢复的物料');
      //   return;
      // }
      // this.$confirm('恢复此记录, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      // .then(() => {
      //     this.changeDataStatus(matterApi.restore,"修改成功！","");
      // });
    },
    cancelSelect() {
      this.fromData = {};
      this.isShowMaterialDialog = false;
    },
    async selectMattersOk() {
      console.log(this.fromData)
      this.$refs.content.validataForm();
      let baseRes = this.fromData.regRes;
      if (!baseRes) return;
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";

      let materialGroupId = this.fromData.materialGroupId;
      var postUrl = MatcatmanageApi.add;
      if (materialGroupId) postUrl = MatcatmanageApi.modify;
      let res = await this.$post(postUrl, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      this.isLoading = false;
      console.log(res);
      if (res.status) {
        let successMsg = materialGroupId
          ? "物料类别 " + res.data.materialGroupId + "修改成功"
          : "物料类别 " + res.data.materialGroupId + " 已添加成功";
        this.$alert(successMsg, "操作提示", {
          confirmButtonText: "确定",
          type: "success",
          callback: action => {
            this.fromData = {};
            this.$refs.FormGridPanel.getList();
          }
        });
      } else {
        this.$message.error(res.errorMsg);
      }
      this.isShowMaterialDialog = false;
      this.fromData = {};
    }
    /**
     * 检查数据
     */
    // onSubCheck() {},
    /**
     * 提交数据
     */
    // async onSubSave() {

    // }
  }
};
</script>
